import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = ["auditLogsUserName", "auditLogsBallotCode", "auditLogsTableBody"]
  static values = { electionId: Number }

  connect() {
    const auditLogsModalElement = document.getElementById('auditLogsModal')
    this.auditLogsModal = new Modal(auditLogsModalElement)
  }

  async showAuditLogs(event) {
    event.preventDefault()
    const ballotId = event.currentTarget.dataset.ballotId
    const userName = event.currentTarget.dataset.userName
    const ballotCode = event.currentTarget.dataset.ballotCode
    const electionId = event.currentTarget.dataset.electionId || this.electionIdValue

    // Set user info in modal
    this.auditLogsUserNameTarget.textContent = userName
    this.auditLogsBallotCodeTarget.textContent = ballotCode

    // Show loading state
    this.auditLogsTableBodyTarget.innerHTML = '<tr><td colspan="4" class="text-center"><span class="spinner-border spinner-border-sm me-2"></span>Loading audit logs...</td></tr>'

    // Show modal
    this.auditLogsModal.show()

    try {
      const response = await fetch(`/admin/elections/${electionId}/election_ballots/${ballotId}/audit_logs.json`)

      if (!response.ok) {
        throw new Error('Failed to fetch audit logs')
      }

      const data = await response.json()

      // Update table with audit logs
      if (data.audit_logs.length === 0) {
        this.auditLogsTableBodyTarget.innerHTML = '<tr><td colspan="4" class="text-center text-muted">No audit logs found for this ballot.</td></tr>'
      } else {
        let tableHTML = ''
        data.audit_logs.forEach(log => {
          // Format action name: convert snake_case to Title Case
          const actionDisplay = this.formatActionName(log.action)

          // Get badge color based on action type
          const badgeColor = this.getBadgeColor(log.action)

          // Format details if present
          const detailsDisplay = this.formatDetails(log.details)

          tableHTML += `
            <tr>
              <td><small>${log.created_at}</small></td>
              <td><span class="badge ${badgeColor}">${actionDisplay}</span></td>
              <td>
                <div>${log.performed_by.name}</div>
                <small class="text-muted">${log.performed_by.email}</small>
              </td>
              <td>${detailsDisplay}</td>
            </tr>
          `
        })

        this.auditLogsTableBodyTarget.innerHTML = tableHTML
      }

    } catch (error) {
      console.error('Error fetching audit logs:', error)
      this.auditLogsTableBodyTarget.innerHTML = '<tr><td colspan="4" class="text-center text-danger">Error loading audit logs</td></tr>'
    }
  }

  getBadgeColor(action) {
    // Color code actions: benign vs critical
    const benignActions = ['access_key_assigned']
    const criticalActions = ['access_key_viewed', 'ballot_email_sent']

    if (benignActions.includes(action)) {
      return 'bg-secondary'
    } else if (criticalActions.includes(action)) {
      return 'bg-warning'
    } else {
      // Default for any future actions
      return 'bg-info'
    }
  }

  formatActionName(action) {
    // Convert snake_case to Title Case
    return action
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  formatDetails(details) {
    if (!details || Object.keys(details).length === 0) {
      return '<span class="text-muted">—</span>'
    }

    // Format details as key-value pairs
    let formattedDetails = '<small>'
    Object.entries(details).forEach(([key, value]) => {
      const keyDisplay = key.charAt(0).toUpperCase() + key.slice(1)
      formattedDetails += `<div><strong>${keyDisplay}:</strong> ${value}</div>`
    })
    formattedDetails += '</small>'

    return formattedDetails
  }
}
